<template>
<div style="display: flex;">
    <PurchaseNav @chooseNav="chooseNav" :currentPath="currentPath" />
    <div class="viewbox">
        <div class="boxOne">
            <div class="title">供应商管理</div>
            <div class="rightHandle">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="toNew">新建供应商</el-button>
            </div>
        </div>

        <div class="boxTwo">
            <div class="txt">已选择{{chooseList.length}}个供应商</div>
            <div class="rightHandle">
                <el-input v-model="filterParam.manufacturerName" placeholder="搜索供应商" prefix-icon="el-icon-search" size="small" style="width:300px;margin-right:10px;" @keyup.enter.native="toSearch"></el-input>
            </div>
        </div>

        <div class="boxTable">
            <el-table style="width:100%;" height="calc(100vh - 300px)" v-loading="tableLoading" :data="purchaserList"
                :header-cell-style="{'background-color':'#F2F2F2','color':'#3A3A3A'}" :row-style="rowStyle"
                @selection-change="selectionChange">
                <el-table-column type="selection" width="45"></el-table-column>
                <el-table-column label="供应商名称">
                    <template slot-scope="scope">
                        <el-link @click.stop="toDetails(scope.row)">{{scope.row.manufacturerName}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="manufacturerNo" label="供应商编号"></el-table-column>
                <el-table-column prop="placeOrigin" label="境内货源地"></el-table-column>
                <el-table-column prop="city" label="所在城市"></el-table-column>
                <el-table-column prop="contactsName" label="联系人"></el-table-column>
                <el-table-column prop="contactsPhone" label="联系方式"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-link type="info" @click.stop="toDetails(scope.row)">查看</el-link>
                        <span style="padding:0 5px;"></span>
                        <el-link type="info" @click.stop="toEdit(scope.row)">编辑</el-link>
                        <span style="padding:0 5px;"></span>
                        <el-link type="info" @click.stop="toCopy(scope.row)">复制</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="bottomPagination">
            <el-button style="float:left;margin:15px 20px;" size="small" icon="el-icon-refresh" @click="onRefresh">刷 新</el-button>
            <el-pagination background layout="total,sizes,prev,pager,next" :page-sizes="[10, 20, 40]" :page-size.sync="pageSize" @size-change="pageSizeChange" :total="totalItems" style="float:right;margin:15px 20px;" :current-page.sync="pageIndex" @current-change="pageIndexChange"></el-pagination>
        </div>

    </div>
</div>
</template>

<script>
import PurchaseNav from "@/components/PurchaseNav.vue";
export default {
    components: { PurchaseNav },
    props: {
        handleSelect: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            currentPath: "/purchase/purchaserManage",
            // 过滤字段
            filterParam: {
                manufacturerName: "",
            },
            //列表展示
            tableLoading: false,
            purchaserList: [],
            totalItems: 0,
            pageIndex: 1,
            pageSize: 10,

            chooseList: [],
        };
    },
    methods: {
        chooseNav(index){
            this.handleSelect(index);
            this.$router.push(index);
        },
        rowStyle({rowIndex}){
            // 表格隔行换色
            if(rowIndex % 2 == 1){
                return {'background-color':'#F9FAFC'}
            }
        },

        onRefresh(){
            this.filterParam = {
                manufacturerName: "",
            };
            this.toSearch();
        },
        toSearch(){
            this.pageIndex = 1;
            this.getList();
        },
        //获取供应商列表
        getList(){
            const {manufacturerName} = this.filterParam;
            this.tableLoading = true;
            this.$axios.post(`${this.$orderUrl}/Purchase/GetPurchaser`,{
                manufacturerName,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
            }).then((res) => {
                const { isSuccess , data } = res;
                this.tableLoading = false;
                if (isSuccess) {
                    this.purchaserList = data.datas;
                    this.totalItems = data.totalItems;
                }
            });
        },
        pageIndexChange(page) {
            this.pageIndex = page;
            this.getList();
        },
        pageSizeChange() {
            this.pageIndex = 1;
            this.getList();
        },

        selectionChange(value){
            console.log(value);
            this.chooseList = value;
        },

        toNew(){
            let routeData = this.$router.resolve({
                path: "/purchase/newPurchaser",
            });
            window.open(routeData.href, "_blank");
        },
        toEdit(row){
            let routeData = this.$router.resolve({
                path: "/purchase/newPurchaser",
                query: { key: row.key },
            });
            window.open(routeData.href, "_blank");
        },
        toCopy(row){
            let routeData = this.$router.resolve({
                path: "/purchase/newPurchaser",
                query: { key: row.key, optype: "copy" },
            });
            window.open(routeData.href, "_blank");
        },
        toDetails(row){
            let routeData = this.$router.resolve({
                path: "/purchase/purchaserDetails",
                query: { key: row.key },
            });
            window.open(routeData.href, "_blank");
        },

    },
    mounted() {
        //获取供应商列表
        this.getList();
    },
};
</script>

<style lang="scss" scoped>
.viewbox{
    width: calc(100% - 200px);
    height: calc(100vh - 140px);
    background: rgba($color: #FFFFFF, $alpha: 0.7);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-bottom: 60px;
    .boxOne,.boxTwo{
        overflow: hidden;
        padding: 8px 0;
        line-height: 32px;
        border-bottom: 1px solid #E6E7EB;
        .cascader {
            float: left;
            margin-left: 20px;
            width: 100px;
            ::v-deep .el-input__inner {
                border: none;
                background: none;
            }
        }
        .title{
            float: left;
            margin-left: 40px;
            font-size: 24px;
            font-weight: bold;
            color: #3A3A3A;
        }
        .txt{
            float: left;
            margin-left: 40px;
            font-size: 16px;
            color: #7C90A5;
        }
        .rightHandle{
            float: right;
            margin-right: 20px;
        }
    }

    .bottomPagination{
        position: fixed;
        bottom: 0;
        right: 0;
        z-index: 10;
        width: calc(100vw - 200px);
        height: 60px;
        background: #FFFFFF;
        box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.16);
    }
}
</style>